
  import createMeisterIcons from '../src/createMeisterIcons';

  const Flag = createMeisterIcons("flag", [["path",{"fill":"currentColor","d":"M7 4.75c-.686 0-1.25.564-1.25 1.25v7.25H17c.686 0 1.25-.564 1.25-1.25V6c0-.686-.564-1.25-1.25-1.25zm-1.25 10H17A2.756 2.756 0 0 0 19.75 12V6A2.756 2.756 0 0 0 17 3.25H7A2.756 2.756 0 0 0 4.25 6v14a.75.75 0 0 0 1.5 0z","key":"21baf369331e608188886181bccb102dfce68dc8","fillRule":"evenodd","clipRule":"evenodd"}]])

  export default Flag
  